import React from "react"
import { Link } from "gatsby"

const NMLSUrl = (
  <a href="https://www.nmlsconsumeraccess.org" rel="noreferrer" target="_blank">
    nmlsconsumeraccess.org
  </a>
)

const Disclosures = props => {
  switch (props.disclosure) {
    default:
      return (
        <p>
          Loan programs may change at any time with or without notice.
          Information deemed reliable but not guaranteed. All loans subject to
          income verification, credit approval and property appraisal. Not a
          commitment to lend. Atlantic Bay Mortgage Group, L.L.C. NMLS #72043 (
          <a
            href="http://www.nmlsconsumeraccess.org"
            rel="noopener noreferrer"
            target="_blank"
          >
            nmlsconsumeraccess.org
          </a>
          ) is an Equal Housing Lender.
        </p>
      )
    case "annual-mortgage-review":
      return (
        <p>
          Information deemed reliable but not guaranteed. All loans subject to
          income verification, credit approval and property appraisal. Not a
          commitment to lend. Atlantic Bay Mortgage Group, L.L.C. NMLS #72043 (
          <a
            href="http://www.nmlsconsumeraccess.org"
            rel="noopener noreferrer"
            target="_blank"
          >
            nmlsconsumeraccess.org
          </a>
          ) is an Equal Opportunity Lender. Located at 600 Lynnhaven Parkway
          Suite 100 Virginia Beach, VA 23452.
        </p>
      )
    case "blog":
      return (
        <p>
          The views and statements expressed are deemed reliable as of the
          publish date indicated and may not be accurate or reliable at any
          future date. The views and statements provided are those of the
          author. Discussions regarding any financial information provided are
          not intended as individual recommendations and do not reflect the
          views or advice of Atlantic Bay Mortgage Group, L.L.C. The views
          expressed are subject to change at any time in response to changing
          circumstances in the market. *For refinances, the total finance
          charges may be higher over the life of the loan. Atlantic Bay Mortgage
          Group, L.L.C. disclaims any obligation to publicly update or revise
          any views expressed or information given. Loan programs may change at
          any time with or without notice. Information deemed reliable but not
          guaranteed. All loans subject to income verification, credit approval
          and property appraisal. Not a commitment to lend. Atlantic Bay
          Mortgage Group, L.L.C. NMLS #72043 (
          <a
            href="http://www.nmlsconsumeraccess.org"
            rel="noopener noreferrer"
            target="_blank"
          >
            nmlsconsumeraccess.org
          </a>
          ) is an Equal Housing Lender. Located at 600 Lynnhaven Parkway Suite
          100 Virginia Beach, VA 23452.
        </p>
      )
    case "keypleaz":
      return (
        <p>
          Loan programs may change at any time with or without notice.
          Information deemed reliable but not guaranteed. All loans subject to
          income verification, credit approval and property appraisal. Not a
          commitment to lend. Atlantic Bay Mortgage Group, L.L.C. NMLS #72043 (
          <a
            href="http://www.nmlsconsumeraccess.org"
            rel="noopener noreferrer"
            target="_blank"
          >
            nmlsconsumeraccess.org
          </a>
          ) is an Equal Opportunity Lender. Located at 600 Lynnhaven Parkway
          Suite 100 Virginia Beach, VA 23452.
        </p>
      )
    case "mbheader":
      return (
        <p>
          Loan programs may change at any time with or without notice.
          Information deemed reliable but not guaranteed. All loans subject to
          income verification, credit approval and property appraisal. Not a
          commitment to lend. Atlantic Bay Mortgage Group, L.L.C. NMLS #72043 (
          <a
            href="http://www.nmlsconsumeraccess.org"
            rel="noopener noreferrer"
            target="_blank"
          >
            nmlsconsumeraccess.org
          </a>
          ) is an Equal Housing Lender. Located at 600 Lynnhaven Parkway Suite
          100 Virginia Beach, VA 23452.
        </p>
      )
    case "mbheader-texas":
      return (
        <p>
          Texas Mortgage Banker Registration and Residential Mortgage Loan
          Servicer Registration #72043. Loan programs may change at any time
          with or without notice. Information deemed reliable but not
          guaranteed. All loans subject to income verification, credit approval
          and property appraisal. Not a commitment to lend. Atlantic Bay
          Mortgage Group, L.L.C. NMLS #72043 (
          <a
            href="http://www.nmlsconsumeraccess.org"
            rel="noopener noreferrer"
            target="_blank"
          >
            nmlsconsumeraccess.org
          </a>
          ) is an Equal Housing Lender. Located at 600 Lynnhaven Parkway Suite
          100 Virginia Beach, VA 23452.
        </p>
      )
    case "internships":
      return (
        <p>
          This communication does not constitute a promise or guarantee of
          employment. Atlantic Bay Mortgage Group, L.L.C. NMLS #72043 ({NMLSUrl}
          ) is an Equal Opportunity Employer.
        </p>
      )
    case "careers":
      return (
        <p>
          This communication does not constitute a promise or guarantee of
          employment. Atlantic Bay Mortgage provides equal employment
          opportunities (EEO) to all employees and applicants for employment
          without regard to race, color, religion, sex, national origin, age,
          disability or genetics. In addition to federal law requirements,
          Atlantic Bay Mortgage complies with applicable state and local laws
          governing nondiscrimination in employment in every location in which
          the company has facilities. Atlantic Bay Mortgage Group, L.L.C. NMLS
          #72043 (
          <a
            href="http://www.nmlsconsumeraccess.org"
            rel="noopener noreferrer"
            target="_blank"
          >
            nmlsconsumeraccess.org
          </a>
          ) is an Equal Housing Lender.
        </p>
      )
    case "black-history":
      return (
        <p>
          Information is for educational purposes only and should not be relied
          upon by you. Information deemed reliable but not guaranteed. All loans
          subject to income verification, credit approval and property
          appraisal. Not a commitment to lend. Atlantic Bay Mortgage Group,
          L.L.C. NMLS #72043 ({" "}
          <a
            href="http://www.nmlsconsumeraccess.org"
            rel="noopener noreferrer"
            target="_blank"
          >
            nmlsconsumeraccess.org
          </a>
          ) is an Equal Opportunity Lender. Located at 600 Lynnhaven Parkway
          Suite 100 Virginia Beach, VA 23452.
        </p>
      )
    case "home":
      return (
        <p>
          Featured statements, testimonials, and opinions are unsolicited and
          may not be representative of all borrowers’ experiences. Individual
          results may vary. Testimonials are voluntarily provided and are not
          paid, nor provided with any benefits in exchange for said statements.
          For more consumer reviews, visit{" "}
          <a
            href="https://www.experience.com/reviews/office/atlantic-bay-mortgage-virgnia-beach-46727"
            rel="noreferrer"
            target="_blank"
          >
            www.experience.com/reviews/office/atlantic-bay-mortgage-virgnia-beach-46727
          </a>
          . Loan programs may change at any time with or without notice.
          Information deemed reliable but not guaranteed. All loans subject to
          income verification, credit approval and property appraisal. Not a
          commitment to lend. Atlantic Bay Mortgage Group, L.L.C. NMLS #72043 (
          {NMLSUrl}) is an Equal Opportunity Lender. Located at 600 Lynnhaven
          Parkway Suite 100, Virginia Beach, VA 23452.{" "}
        </p>
      )
    case "joint-venture":
      return (
        <p>
          All joint ventures are subject to applicable laws and regulations,
          including but not limited to RESPA and fair lending practices. Terms
          and benefits outlined are subject to change based on regulatory
          requirements and mutual agreement. Loan programs may change at any
          time with or without notice. Information deemed reliable but not
          guaranteed. All loans subject to income verification, credit approval
          and property appraisal. Not a commitment to lend. Atlantic Bay
          Mortgage Group, L.L.C. NMLS #72043 ({NMLSUrl}) is an Equal Opportunity
          Lender. Located at 600 Lynnhaven Parkway Suite 100 Virginia Beach, VA
          23452.
        </p>
      )
    case "pillar-page":
      return (
        <p>
          Disclosure: Information is for educational purposes only and should
          not be relied upon by you. Discussions regarding any financial
          information provided are not intended as individual recommendations
          and do not reflect the views or advice of Atlantic Bay Mortgage Group,
          L.L.C. The views expressed are subject to change at any time in
          response to changing circumstances in the market. Other loan program
          restrictions and eligibility requirements may apply. For refinances,
          the total finance charges may be higher over the life of the loan.
          Atlantic Bay Mortgage Group, L.L.C. disclaims any obligation to
          publicly update or revise any views expressed or information given.
          Loan programs may change at any time with or without notice.
          Information deemed reliable but not guaranteed. All loans subject to
          income verification, credit approval and property appraisal. Not a
          commitment to lend. Atlantic Bay Mortgage Group, L.L.C. NMLS #72043 (
          <a href="nmlsconsumeraccess.org" target="_blank">
            nmlsconsumeraccess.org
          </a>
          ) is an Equal Housing Lender. Located at 600 Lynnhaven Parkway Suite
          100 Virginia Beach, VA 23452.
        </p>
      )
    case "sms":
      return (
        <p>
          By providing a telephone number and submitting the form, I expressly
          consent and authorize Atlantic Bay Mortgage Group, L.L.C. and its
          representatives to contact me by phone, SMS text message, or email.
          Message and data rates may apply. You consent to the use of automated
          dialing systems, prerecorded or artificial voice messages, and AI
          (Artificial Intelligence) technology to facilitate calls or texts for
          both marketing and customer service purposes. Message frequency may
          vary. You can reply “STOP” to opt out of further text messages. Reply
          HELP for more information. To opt-out of email marketing communication
          click unsubscribe at the bottom of the email. Your consent is not a
          condition of any loan application or approval. To learn more about
          SMS/text correspondence visit{" "}
          <Link to="/online-privacy-policy#sms-terms-and-conditions">
            https://www.atlanticbay.com/online-privacy-policy#sms-terms-and-conditions
          </Link>
          . For information on how we protect your data and respect your
          privacy, please review our{" "}
          <Link to="/privacy-policy/">Privacy Policy</Link>. To opt out of
          marketing communications, visit{" "}
          <Link to="/opt-out/">https://www.atlanticbay.com/opt-out/.</Link>
        </p>
      )
    case "tu-hogar-tu-futuro":
      return (
        <p>
          Information is for educational purposes only and should not be relied
          upon by you. Information deemed reliable but not guaranteed, featured
          products and programs subject to change. All loans subject to income
          verification, credit approval and property appraisal. Not a commitment
          to lend. Atlantic Bay Mortgage Group, L.L.C. NMLS #72043
          (nmlsconsumeraccess.org) is an Equal Opportunity Lender. #72043 (
          <a
            href="http://www.nmlsconsumeraccess.org"
            rel="noopener noreferrer"
            target="_blank"
          >
            nmlsconsumeraccess.org
          </a>
          ) is an Equal Housing Lender. Located at 600 Lynnhaven Parkway Suite
          100 Virginia Beach, VA 23452. Atlantic Bay Mortgage Group, L.L.C. NMLS
        </p>
      )
    case "tu-hogar-tu-futuro-spanish":
      return (
        <p>
          Esta información es únicamente para fines educativos y usted no debe
          basarse en ella para tomar decisiones. La información se considera
          fidedigna, pero no está garantizada. Todos los préstamos están sujetos
          a la verificación de ingresos, a la aprobación de crédito y a la
          tasación de la propiedad. No constituye un compromiso del otorgamiento
          de un préstamo. Atlantic Bay Mortgage Group, L.L.C., NMLS n.º 72043 (
          <a
            href="http://www.nmlsconsumeraccess.org"
            rel="noopener noreferrer"
            target="_blank"
          >
            nmlsconsumeraccess.org
          </a>
          ) , es un prestamista que ofrece igualdad de oportunidades con sede en
          600 Lynnhaven Parkway Suite 203, Virginia Beach, VA 23452.
        </p>
      )
    case "lender-for-life":
      return (
        <p>
          Information is for educational purposes only and should not be relied
          upon by you. Loan programs may change at any time with or without
          notice. Information deemed reliable but not guaranteed. All loans
          subject to income verification, credit approval and property
          appraisal. Not a commitment to lend. Atlantic Bay Mortgage Group,
          L.L.C. NMLS #72043 (
          <a
            href="http://www.nmlsconsumeraccess.org"
            rel="noopener noreferrer"
            target="_blank"
          >
            nmlsconsumeraccess.org
          </a>
          ) is an Equal Housing Lender.
        </p>
      )
    case "smartpath":
      return (
        <p>
          Information is for educational purposes only and should not be relied
          upon by you. Information deemed reliable but not guaranteed, featured
          products and programs subject to change. All loans subject to income
          verification, credit approval and property appraisal. Not a commitment
          to lend. Atlantic Bay Mortgage Group, L.L.C. NMLS #72043
          (nmlsconsumeraccess.org) is an Equal Opportunity Lender. #72043 (
          <a
            href="http://www.nmlsconsumeraccess.org"
            rel="noopener noreferrer"
            target="_blank"
          >
            nmlsconsumeraccess.org
          </a>
          ) is an Equal Housing Lender. Located at 600 Lynnhaven Parkway Suite
          100 Virginia Beach, VA 23452. Atlantic Bay Mortgage Group, L.L.C. NMLS
        </p>
      )
    case "works":
      return (
        <>
          <p>
            *AB Insurance LLC is a joint venture between Atlantic Bay Mortgage
            Group and Prosper Insurance. AB Insurance is a full-service
            insurance agency. This is for informational purposes only and AB
            Insurance does not regulate insurance premiums or products. Products
            and rates may vary by state. All Access Services is not affiliated
            with Atlantic Bay Mortgage Group.{" "}
            <em>
              Additional terms, conditions, and coverage limitations may apply.
              Contact provider for more information.
            </em>
          </p>
          <p>
            <sup>†</sup>Lender credit of .25% of the total loan amount not to
            exceed $2,000 or amount allowed per program guidelines.
          </p>
          <p
            css={`
              margin-bottom: 0;
            `}
          >
            All information deemed reliable but not guaranteed. Limit one
            promotion per transaction. Must be presented at the time of
            application. Atlantic Bay Mortgage Group, L.L.C. is not responsible
            for compensation of all benefits listed. Other loan program
            restrictions may apply. Loan programs, interest rates, and fees are
            subject to change without notice. All loans subject to income
            verification, credit approval and property appraisal. Not a
            commitment to lend. Atlantic Bay Mortgage Group, L.L.C. NMLS #72043
            (nmlsconsumeraccess.org) is an Equal Opportunity Lender. Located at
            600 Lynnhaven Parkway Suite 100 Virginia Beach, VA 23452.
          </p>
        </>
      )
  }
}

export default Disclosures
